import { render, staticRenderFns } from "./MessageSentConfirmation.vue?vue&type=template&id=3f351a4c&scoped=true&"
import script from "./MessageSentConfirmation.vue?vue&type=script&lang=js&"
export * from "./MessageSentConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MessageSentConfirmation.vue?vue&type=style&index=0&id=3f351a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f351a4c",
  null
  
)

export default component.exports